import script from "./DefaultFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultFooter.vue?vue&type=script&setup=true&lang=js"

import "./DefaultFooter.vue?vue&type=style&index=0&id=3fdc973e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fdc973e"]])

export default __exports__